import * as React from "react";
function SvgTorusWalletIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return <svg width="34" height="36" viewBox="0 0 34 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M20 0H0V10.6667H20V0Z" fill="#0364FF" />
            <path d="M20 0H9.33316V36H19.9998L20 0Z" fill="#0364FF" />
            <path d="M27.9998 10.6667C30.9453 10.6667 33.3331 8.27886 33.3331 5.33333C33.3331 2.38781 30.9453 0 27.9998 0C25.0543 0 22.6665 2.38781 22.6665 5.33333C22.6665 8.27886 25.0543 10.6667 27.9998 10.6667Z" fill="#0364FF" />
        </svg>;
}
export default SvgTorusWalletIcon;